export class Error {
  Warning: boolean;
  Message: string;
  Data: string;

  constructor(data?: Partial<Error>) {
    Object.assign(this, data);
  }
}
